module.exports = ".showpanel{\nopacity: 1 !important;\n}\n.hidepanel{\nopacity: 0;\n-webkit-transition: .5s ease-in-out all;\ntransition: .5s ease-in-out all;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core.module/modules/panel.module/panel.component.css
// module id = ./src/app/core.module/modules/panel.module/panel.component.css
// module chunks = main